import { Component, OnInit } from '@angular/core';
import { ReservationService } from '../../../service/reservation-service/reservation.service';
import { decryptField } from '../../../utils/decrypt-utils';
import { getReservationStatus } from '../../../utils/placement-status';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.css']
})
export class ReservationsComponent implements OnInit {

  reservations: any[] = [];
  isLoading: boolean = false;
  search: string = '';
  selectedReservationId: number | string | null = null;
  selectedMemberId: string = null;
  constructor(private reservationService: ReservationService) { }

  ngOnInit() {
    this.getReservationsList();
  }

  getReservationsList() {
    this.isLoading = true;
    this.reservationService.getReservations().subscribe(
      (response: any) => {
        let rawReservations = [];
        if (response && response.data) {
          rawReservations = response.data;
        } else if (Array.isArray(response)) {
          rawReservations = response;
        } else {
          rawReservations = response.reservations || [];
        }

        this.reservations = rawReservations.map((res: any) => {
          const patient = (res.e_intakes && res.e_intakes.e_patients) || {};
          return {
            ...res,
            patient_first_name: decryptField(patient.first_name),
            patient_last_name: decryptField(patient.last_name),
            ref_id: decryptField(patient.reference_id),
            ref_name: decryptField(patient.reference_name),
            ref_phone: decryptField(patient.reference_phone)
          };
        });

        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching reservations:', error);
        this.isLoading = false;
      }
    );
  }


  getReservationStatus(statusId: number): { label: string; color: string } {
    return getReservationStatus(statusId);
  }

  openReservationDetails(reservation: any): void {
    const id = reservation ? (reservation.id || reservation._id) : null;
    if (id) {
      this.selectedReservationId = id;
    }
  }

  openMemberModal(memberId: string): void {
    if (memberId) {
      this.selectedMemberId = memberId;
    }
  }

  closeReservationModal(): void {
    this.selectedReservationId = null;
  }
}
